/** Brand-coloured kit-picker grid — step 2 of the guided log flow. */

import type { TestKit } from '@reefapp/shared';
import { getKitBranding } from './kitBranding';

export interface KitPickerProps {
  kits: ReadonlyArray<TestKit>;
  onSelect: (kit: TestKit) => void;
}

export function KitPicker({ kits, onSelect }: KitPickerProps): JSX.Element {
  if (kits.length === 0) {
    return (
      <p className="text-sm text-muted-foreground text-center py-6">
        No test kits available for this parameter.
      </p>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
      {kits.map((kit) => {
        const brand = getKitBranding(kit);
        return (
          <button
            key={`${kit.brand}-${kit.name}`}
            type="button"
            onClick={() => onSelect(kit)}
            style={{ backgroundColor: brand.color, color: brand.textColor }}
            className="rounded-xl px-3 py-4 flex flex-col items-center gap-1 text-center shadow-sm
                       hover:opacity-90 active:scale-95 transition-all duration-150 focus-visible:outline
                       focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
          >
            <span className="text-xs font-semibold uppercase tracking-wider opacity-80">
              {brand.displayBrand}
            </span>
            <span className="text-sm font-bold leading-tight">{brand.productName}</span>
          </button>
        );
      })}
    </div>
  );
}
